module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_global_issues_black.f1f1ac9c.png";